import { from, interval, EMPTY } from "rxjs";
import { map, distinctUntilChanged, switchMap, catchError } from "rxjs/operators";
import { adminApi } from '../apis/adminApi';

const role$ = (store) => from(store).pipe(
    map((state) => state.auth.Role),
    distinctUntilChanged()
);

export const monitorAdminRole = (store) => {
    role$(store).pipe(
        switchMap((role) => {
            if (role === 'Admin') {
                return interval(30000).pipe(
                    switchMap(() => {
                        store.dispatch(adminApi.endpoints.fetchData.initiate());
                        return EMPTY;
                    })
                );
            }
            return EMPTY;
        }),
        catchError(() => EMPTY)
    ).subscribe();
};
